import {Injectable} from "@angular/core";
import {NgxSmartModalComponent, NgxSmartModalService} from "ngx-smart-modal";

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  constructor(
    private ngxModalService: NgxSmartModalService
  ) {
  }

  getModal(id: string): NgxSmartModalComponent {
    return this.ngxModalService.getModal(id);
  }

  open(id: string, force = true): void {
    this.ngxModalService.open(id, force)
  }

  close(id: string): void {
    this.ngxModalService.close(id);
  }

}
